import { useMemo, useRef } from 'react';
import styled from 'styled-components';
import { Popup } from '@elfsight/widget-modal';
import { parseWidth } from '@elfsight/widget-utils';
import { ProportionalContainer } from '../common';
import { Layout } from '../layout';
import { Pair } from '../pair';

const accentColor = 'rgb(255, 255, 255)';

interface FullscreenProps {
  popupWidth: string | number;
  imageRatio: number;
  pairs: any;
  pairProps: any;
  open: boolean;
  isMobile: boolean;
  selectedPair: string | null;
  onCloseRequest: () => void;
}

export function Fullscreen({
  popupWidth,
  imageRatio,
  pairs,
  pairProps,
  open: isOpen,
  isMobile,
  selectedPair,
  onCloseRequest
}: FullscreenProps) {
  const contentRef = useRef();

  const slideIndex = useMemo(
    () =>
      selectedPair && pairs?.length > 0
        ? pairs.findIndex(({ id: pairId }) => pairId === selectedPair)
        : null,
    [selectedPair]
  );

  const renderContent = (width: number, height: number) => {
    if (!pairs?.length) {
      return;
    }

    return (
      <Layout
        type="carousel"
        viewWidth={width}
        viewHeight={height}
        controlsColor={accentColor}
        slideIndex={slideIndex}
        compact={false}
      >
        {pairs.map((data) => (
          <Pair
            key={data.id}
            {...pairProps}
            withCaptionMagicMargins
            captionColor={accentColor}
            viewWidth={width}
            viewHeight={height}
            data={data}
            fullscreenEnabled={false}
          />
        ))}
      </Layout>
    );
  };

  return (
    <Popup
      show={isOpen}
      backdropColor="rgba(0, 0, 0, 0.85)"
      onCloseRequest={onCloseRequest}
      closeControlPosition="outside"
      withBackdrop
      fixed
      withCloseControl
      closeOnOutsideClick
      disableScroll
      closeOnEscape
      width={parseWidth(popupWidth)}
      margin={isMobile ? 20 : 70}
      style={isMobile ? { margin: 'auto' } : undefined}
      ariaLabel="Before and After Slider fullscreen popup"
    >
      <Content ref={contentRef}>
        <ProportionalContainer ref={contentRef} ratio={imageRatio}>
          {renderContent}
        </ProportionalContainer>
      </Content>
    </Popup>
  );
}

const Content = styled.div``;
